// plugins/tinymce.js
export default defineNuxtPlugin(() => {
  if (process.client) {
    // Set license key as early as possible
    if (typeof window !== 'undefined') {
      // Method 1: Set on window before TinyMCE loads
      window.TINYMCE_LICENSE_KEY = 'gpl';

      // Method 2: Set on tinymce object
      window.tinymce = window.tinymce || {};
      window.tinymce.license_key = 'gpl';

      // Method 3: Set default settings
      window.tinymce.defaultSettings = window.tinymce.defaultSettings || {};
      window.tinymce.defaultSettings.license_key = 'gpl';

      // Method 4: Override init method to ensure license key is always set
      const originalInit = window.tinymce?.init;
      window.tinymce.init = function (config) {
        config = config || {};
        config.license_key = 'gpl';
        return originalInit ? originalInit.call(this, config) : null;
      };

      // Method 5: Add to global config
      window.tinymceGlobalConfig = {
        license_key: 'gpl',
      };
    }
  }
});
